// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Jhqdx","toggle":"styles_toggle__3HQSo","preview":"styles_preview__3ILa0"};